module.exports = __webpack_public_path__ + "media/images/sp/static/icon-reference-4a42aefe66edd7ab6b2e5acf5254b3c0.png";